import Archived from 'assets/image/icons/svg/icons/archived.svg'
import Spam from 'assets/image/icons/svg/icons/spam.svg'

import { Filter, MailboxFilter } from '../model/types'

interface FilterItem {
	icon: string
	key: Filter
	title: string
}

const FILTERS: FilterItem[] = [
	{ icon: Archived, key: 'archive', title: 'Archived' },
	{ icon: Spam, key: 'spam', title: 'Spam' }
]

interface ChipFilterItem {
	key: MailboxFilter
	title: string;
}

const CHIP_FILTERS: ChipFilterItem[] = [
	{ key: 'unread', title: 'Unread' },
	{ key: 'in-mail', title: 'InMail' },
	{ key: 'myConnections', title: 'My Connections' },
	{ key: 'starred', title: 'Starred' }
]

interface Tab {
	label: string
	value: Filter
}

const TABS: Tab[] = [
	{
		label: 'Focused',
		value: 'focused'
	},
	{
		label: 'Other',
		value: 'other'
	}
]

export { CHIP_FILTERS, FILTERS, TABS }
